import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
} from "@mui/icons-material";
import {
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    GetAllSunlightRates,
    sunlightRatesReset,
} from "../../Redux/Finance/SunlightRates/SunlightRatesSlice";

function AllSunlightRates() {
    const dispatch = useDispatch();

    const { sunlights, isLoading, isSuccess, isError } = useSelector(
        (state) => state.sunlight_rates
    );

    const AllSunlight = sunlights?.data || [];
    useEffect(() => {
        const CallGetAllSunlightRates = async () => {
            await dispatch(GetAllSunlightRates());
            await dispatch(sunlightRatesReset());
        };
        CallGetAllSunlightRates();
    }, [dispatch]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell align="center"> # </TableCell>
                                <TableCell align="center"> Name </TableCell>
                                <TableCell align="center"> Term </TableCell>
                                <TableCell align="center"> APR </TableCell>
                                <TableCell align="center">
                                    {" "}
                                    Dealer Fee{" "}
                                </TableCell>
                                <TableCell align="center">
                                    {" "}
                                    PMTS First Year{" "}
                                </TableCell>
                                <TableCell align="center">
                                    {" "}
                                    PMTS Other Years{" "}
                                </TableCell>
                                <TableCell align="center"> ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {AllSunlight.map((rate, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>{index + 1}</TableCellStyle>
                                    <TableCellStyle>
                                        {rate.name || "___"}
                                    </TableCellStyle>
                                    <TableCellStyle>{rate.term}</TableCellStyle>
                                    <TableCellStyle>{rate.apr}</TableCellStyle>
                                    <TableCellStyle>
                                        {rate.dealer_fee}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        {rate.pmts_first_year}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        {rate.pmts_other_years}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <IconButton>
                                            <Link to={"edit=" + rate.id}>
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton>
                                            <ProgressStyled>
                                                <Delete color="error" />
                                            </ProgressStyled>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>

                    {/* delete modal  */}
                    {/* <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    /> */}
                </TableContainerStyled>
            )}
        </>
    );
}

export default AllSunlightRates;
